import { FC, MouseEvent, useState } from "react";
import { Box } from "@mui/material";
import CloseSvg from "@/assets/svg/CloseSvg";
import welcomeVideoThumbnail from "@/assets/image/WelcomeVideoThumbnail.jpg";
import { styles } from "./stylesWelcomePopup";

const WELCOME_VIDEO_ID = "Hc0sMrETHPI";
const WELCOME_VIDEO_URL = `https://youtu.be/${WELCOME_VIDEO_ID}`;
const WELCOME_VIDEO_EMBED_URL = `https://www.youtube.com/embed/${WELCOME_VIDEO_ID}?autoplay=1&rel=0`;

interface WelcomePopupProps {
  onClose: () => void;
}

const WelcomePopup: FC<WelcomePopupProps> = ({ onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Box sx={styles.card}>
      <Box sx={styles.headerGroup}>
        <Box sx={styles.header}>
          <Box component="p" sx={styles.title}>
            Welcome to Wethemarkt!
          </Box>
          <Box sx={styles.closeButton} onClick={onClose} aria-label="Close">
            <CloseSvg size={20} color="#99A1AF" />
          </Box>
        </Box>
        <Box component="p" sx={styles.description}>
          New here? Watch a quick walkthrough and discover how traders share ideas, track stocks,
          and connect with the community.
        </Box>
      </Box>
      <Box sx={styles.videoWrapper}>
        <Box sx={styles.videoThumbnail}>
          {isPlaying ? (
            <Box
              component="iframe"
              src={WELCOME_VIDEO_EMBED_URL}
              title="Wethemrkt - How to use"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sx={styles.videoIframe}
            />
          ) : (
            <>
              <Box
                component="img"
                src={welcomeVideoThumbnail}
                alt="Wethemrkt - How to use"
                sx={styles.videoThumbnailImg}
              />
              <Box
                sx={styles.playHitArea}
                onClick={() => setIsPlaying(true)}
                aria-label="Play video"
              />
              <Box
                component="a"
                href={WELCOME_VIDEO_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={styles.openHitArea}
                aria-label="Open in YouTube"
                onClick={(e: MouseEvent) => e.stopPropagation()}
              />
            </>
          )}
        </Box>
        <Box sx={styles.maybeLater} onClick={onClose}>
          Maybe later
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomePopup;
